import angular from 'angular'
import { ApiCustomer } from '@vend/types'
import { getDisplayNameFromApiCustomer } from '@vend/react-utilities'

/**
 * Get the name to display for the given customer. Will fall back on the customer's name if there is no
 * company name record.
 *
 * @param  customer The customer to get the name of
 *
 * @return The company name or name of the given customer
 */
export function customerName(customer: ApiCustomer): string | null {
  return getDisplayNameFromApiCustomer(customer)
}

/**
 * Filter for getting the name of a Customer.
 *
 * @module webregister.filters.wrCustomerName
 */
angular.module('webregister.filters').filter('wrCustomerName', function () {
  return customerName
})
